"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkIfObjectsOverlapping = void 0;
var checkIfObjectsOverlapping = function (object1, object2) {
    if (!object1.end_timestamp || !object2.end_timestamp || !object1.start_timestamp || !object2.start_timestamp) {
        return false;
    }
    return object1.start_timestamp < object2.end_timestamp && object1.end_timestamp > object2.start_timestamp;
};
exports.checkIfObjectsOverlapping = checkIfObjectsOverlapping;
